import React from 'react';
import './ImpactSection.css';

// Importar imágenes de donaciones
import donacion01 from '../../assets/logos/donacion_01.jpeg';
import doggyPinata from '../../assets/logos/doggy_pinata.webp';

/**
 * SECCIÓN 2: FUNDACIÓN DOGGY — Impacto Social
 * Split visual: Perritos | Niños + card flotante
 */

const ImpactSection = () => {
  return (
    <section className="impact section" id="impacto">
      <div className="container">
        {/* Split visual: Perritos | Niños */}
        <div className="impact__split">
          {/* Columna Perritos */}
          <div className="impact__column impact__column--perritos">
            <div className="impact__column-photo">
              <img src={donacion01} alt="Donación a albergue de perritos" loading="lazy" />
              <div className="impact__photo-overlay">
                <span className="impact__photo-overlay-emoji">🐕</span>
                <p className="impact__photo-overlay-text">
                  Donamos croquetas y cobijas<br/>a albergue con <strong>+100 perros</strong>
                </p>
              </div>
            </div>
          </div>

          {/* Columna Niños */}
          <div className="impact__column impact__column--ninos">
            <div className="impact__column-photo">
              <img src={doggyPinata} alt="Pizza y piñata con doggy" loading="lazy" />
              <div className="impact__photo-overlay">
                <span className="impact__photo-overlay-emoji">🍕</span>
                <p className="impact__photo-overlay-text">
                  Llevamos pizza y piñata<br/>a <strong>+50 niños</strong> en navidad
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
